var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { addCdpConsent } from './consent/index.js';
/*
 * Adds the Chord CDP snippet to the page.
 */
export const addCdpSnippet = (options) => __awaiter(void 0, void 0, void 0, function* () {
    if (!document || typeof document.createElement === 'undefined')
        return;
    const s = document.createElement('script');
    s.async = true;
    s.src = `${options.cdpDomain}/p.js`;
    s.setAttribute('data-debug', `${!!options.debug}`);
    s.setAttribute('data-init-only', 'true');
    s.setAttribute('data-namespace', `_${options.namespace}`);
    s.setAttribute('data-write-key', options.cdpWriteKey);
    if (options.consent)
        yield addCdpConsent(options).init();
    document.head.appendChild(s);
});
/*
 * Returns the CDP queue to hold events ahead of CDP initialization.
 */
export const cdpQueue = (namespace) => {
    var _a;
    const q = window && (window[_a = `_${namespace}Q`] || (window[_a] = []));
    return {
        track: (...args) => q.push((cdp) => cdp.track(...args)),
        identify: (...args) => q.push((cdp) => cdp.identify(...args)),
        page: (...args) => q.push((cdp) => cdp.page(...args)),
        reset: (...args) => q.push((cdp) => cdp.reset(...args)),
    };
};
